var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 10.625C5.592 10.625 0 12.0457 0 14.875V17H16.8V14.875C16.8 12.0457 11.208 10.625 8.4 10.625ZM2.808 14.5714C3.816 13.8671 6.252 13.0536 8.4 13.0536C10.548 13.0536 12.984 13.8671 13.992 14.5714H2.808ZM8.4 8.5C10.716 8.5 12.6 6.59357 12.6 4.25C12.6 1.90643 10.716 0 8.4 0C6.084 0 4.2 1.90643 4.2 4.25C4.2 6.59357 6.084 8.5 8.4 8.5ZM8.4 2.42857C9.396 2.42857 10.2 3.24214 10.2 4.25C10.2 5.25786 9.396 6.07143 8.4 6.07143C7.404 6.07143 6.6 5.25786 6.6 4.25C6.6 3.24214 7.404 2.42857 8.4 2.42857ZM16.848 10.6979C18.24 11.7179 19.2 13.0779 19.2 14.875V17H24V14.875C24 12.4221 19.8 11.0257 16.848 10.6979ZM15.6 8.5C17.916 8.5 19.8 6.59357 19.8 4.25C19.8 1.90643 17.916 0 15.6 0C14.952 0 14.352 0.157857 13.8 0.425C14.556 1.50571 15 2.82929 15 4.25C15 5.67071 14.556 6.99429 13.8 8.075C14.352 8.34214 14.952 8.5 15.6 8.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.aa8a2ec0008105e5f54a0e106dad2dc6.svg";
export { ForwardRef as ReactComponent };